<div class="custom-dialog-container  message">

  <h2 mat-dialog-title [ngStyle]="{'text-align':data.alignTitle} ">
    @if (data.sucess) {
      <mat-icon style="color:#39813f;margin-right: 5px;">check_circle</mat-icon>
    }
    @if (data.warn) {
      <mat-icon style="color: #ed6102; margin-right: 5px;">warning</mat-icon>
    }
    @if (data.error) {
      <mat-icon style="color: #ff0000; margin-right: 5px;">error</mat-icon>
    }

    @if (data.title) {
      <span class="title" [innerHTML]="data.title | safeHtml" ></span>
    }
  </h2>

  <mat-dialog-content class="mat-typography">

    @if (data.message) {
      <div
        [innerHTML]="data.message | safeHtml"
        [ngStyle]="{'text-align':data.alignMessage }"
      ></div>
    }
    <br />
    <br />
  </mat-dialog-content>

  <mat-dialog-actions>
    @if (data.confirm) {
      <div style="width:100%; text-align:center; ">
        <button mat-raised-button (click)="dialogRef.close('yes')" color="warn">
          <mat-icon>check</mat-icon> Yes
        </button>
        <button mat-raised-button (click)="dialogRef.close('no')" color="primary">
          <mat-icon>close</mat-icon> No
        </button>
      </div>
    }
    @if (!data.confirm) {
      <div style="width:100%; text-align:center; ">
        <button mat-raised-button (click)="dialogRef.close('ok')" color="primary">Ok</button>
      </div>
    }
  </mat-dialog-actions>


</div>
